import { render, staticRenderFns } from "./StarRatings.vue?vue&type=template&id=2986e66e&scoped=true"
import script from "./StarRatings.vue?vue&type=script&lang=ts"
export * from "./StarRatings.vue?vue&type=script&lang=ts"
import style0 from "./StarRatings.vue?vue&type=style&index=0&id=2986e66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986e66e",
  null
  
)

export default component.exports